import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mulesoft/anypoint-components/lib/TextField';
import styles from './BasicInformationSection.css';

/**
 * BasicInformationSection Component
 *
 * Renders the basic information fields for scanner configuration:
 * - Scanner Name (required)
 * - Description (optional)
 */
const BasicInformationSection = ({ name, description, onChange }) => {
  const handleNameChange = useCallback(
    ({ value }) => {
      onChange('name', value);
    },
    [onChange]
  );

  const handleDescriptionChange = useCallback(
    ({ value }) => {
      onChange('description', value);
    },
    [onChange]
  );

  return (
    <div className={styles.section} data-test-id="basic-information-section">
      <div className={styles.field}>
        <label htmlFor="scanner-name" className={styles.label}>
          Name <span className={styles.required}>*</span>
        </label>
        <div className={styles['field-content']}>
          <TextField
            id="scanner-name"
            name="name"
            value={name}
            onChange={handleNameChange}
            placeholder="Enter scanner name"
            required
            testId="scanner-name-input"
          />
        </div>
      </div>

      <div className={styles.field}>
        <label htmlFor="scanner-description" className={styles.label}>
          Description (Optional)
        </label>
        <div className={styles['field-content']}>
          <TextField
            id="scanner-description"
            name="description"
            value={description}
            onChange={handleDescriptionChange}
            placeholder="Enter scanner description (optional)"
            testId="scanner-description-input"
          />
        </div>
      </div>
    </div>
  );
};

BasicInformationSection.propTypes = {
  /** Scanner name value */
  name: PropTypes.string,
  /** Description value */
  description: PropTypes.string,
  /** Change handler for form fields */
  onChange: PropTypes.func.isRequired
};

BasicInformationSection.defaultProps = {
  name: '',
  description: ''
};

export default BasicInformationSection;
